import { render } from "./UserControllerType.vue?vue&type=template&id=6d9aa5ec&scoped=true"
import script from "./UserControllerType.vue?vue&type=script&lang=js"
export * from "./UserControllerType.vue?vue&type=script&lang=js"

import "./UserControllerType.vue?vue&type=style&index=0&id=6d9aa5ec&lang=scss&scoped=true"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d9aa5ec"]])

export default __exports__